exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-slide[data-v-1ceff1a5] {\n  height: 67px !important;\n  width: 60px !important;\n  margin-right: 10px !important;\n  margin: auto !important;\n  text-align: center !important;\n}\n.swiper-container[data-v-1ceff1a5] {\n  margin-top: 20px !important;\n}\n.icon-link-slider .nav-title[data-v-1ceff1a5] {\n  font-size: 11px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 62px;\n  margin: 0 auto;\n  font-weight: 500;\n}", ""]);

// exports
